export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4031f9da3a5c02dabddf54d42d86210e0c74d56353&name=revalidateCommunity!'